// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1nptS","header":"PatientQuestionnaire_header__1YpY8","info":"PatientQuestionnaire_info__2R0sz"};